import React, { useContext, useState } from 'react'
import cahtIcon from '../../../img/icons/caht.png'
import fullScreenIcon from '../../../img/icons/fullScreen.png'
import leaveSessionIcon from '../../../img/icons/leaveSession.png'
import shareScreenActive from '../../../img/icons/shareScreenActive.png'
import shareScreenDisable from '../../../img/icons/shareScreenDisable.png'
import shareScreenNotActive from '../../../img/icons/shareScreenNotActive.png'
import videoActive from '../../../img/icons/video-stream-active.png'
import videoNotActive from '../../../img/icons/video-stream-not-active.png'
import voiceActive from '../../../img/icons/voice-active.png'
import voiceNotActive from '../../../img/icons/voiceNotActive.png'
import { Tooltip } from '../Tooltip/Tooltip'
import styles from './Controllers.module.css'
import { MainContext } from '../../../utils/context'
import { MdFiberManualRecord } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux'
import { startRecord, stopRecord } from '../../../actions/main'

export const Controllers = ({ positionDown }) => {
  
  const {
    toggleAudio,
    toggleVideo,
    toggleScreenShare,
    leaveRoom,
    localParticipant,
    setFoolScreen,
    initiator,
    roomName
  } = useContext(MainContext)

  const {  isAudioEnabled, isVideoEnabled, screenShareTrack } = localParticipant

  const dispatch = useDispatch()
  const {loading, recordId} = useSelector(state => state.main)


  const toggleRecording = () => {
    if (loading) return;
    const action = recordId ? stopRecord(recordId) : startRecord(roomName)
    dispatch(action)
  }

  return (
    <div className={`${styles.wrapper} ${positionDown && styles.positionDown}`}>
      <Tooltip content='микрофон'>
        <img
          src={isAudioEnabled ? voiceActive : voiceNotActive}
          alt="o_O"
          onClick={toggleAudio}
        />
      </Tooltip>
      <Tooltip content='камера'>
        <img
          src={isVideoEnabled ? videoActive : videoNotActive}
          alt="o_O"
          onClick={toggleVideo}
        />
      </Tooltip>
      <Tooltip content='показать экран'>
        <img
          src={ !!screenShareTrack ? shareScreenActive : shareScreenNotActive }
          alt="o_O"
          onClick={toggleScreenShare}
        />
      </Tooltip>
      <Tooltip content='покинуть сеанс'>
        <img
          src={leaveSessionIcon}
          alt="o_O"
          onClick={leaveRoom}
        />
      </Tooltip>
      <Tooltip content='на весь экран'>
        <img
          src={fullScreenIcon}
          alt="o_O"
          onClick={() => setFoolScreen(localParticipant)}
        />
      </Tooltip>
      <Tooltip content='Чат'>
        <img
          src={cahtIcon}
          alt="o_O"
          // onClick={handleChatClick}
        />
      </Tooltip>
      
        {initiator &&
          <Tooltip content='Запись'>
            <i>
              <MdFiberManualRecord
                className={!!recordId && styles.pulse}
                color={recordId ? 'red' : '#d2d2d2'}
                onClick={toggleRecording}
                size={36}
              />
            </i>
          </Tooltip>
        }
    </div>
  )
}
